import { axiosInstance } from "../../../config/axios";

export const getOrderStatus = async (row, page = 1, filters = {}) => {
	try {
		const res = await axiosInstance.get("order-status/", {
			params: { page_size: row, page: page, ...filters },
		});
		const { data } = res;
		data["success"] = true;
		return data;
	} catch (e) {
		const data = {
			success: false,
			results: [],
		};
		return data;
	}
};

export const CreateOrderStatusHistory = async (id, formdata) => {
	try {
		const res = await axiosInstance.post(
			`order-status-history/${id}`,
			formdata
		);
		console.log(res);
		const { data } = res;
		data["success"] = true;
		return data;
	} catch (e) {
		console.log("====================================");
		console.log(e);
		console.log("====================================");
		const data = {
			success: false,
		};
		return data;
	}
};

export const CreateLineStatusHistory = async (id, formdata) => {
	try {
		const res = await axiosInstance.post(
			`line-status-history/${id}`,
			formdata
		);
		console.log(res);
		const { data } = res;
		data["success"] = true;
		return data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};
